import {createActionWithPayload} from "../utils.actions";
import {KeyValue} from "../../reducers/auto-complete/autocomplete-authors.reducer";

export const [autoCompleteAuthors, isAutoCompleteAuthorsAction] = createActionWithPayload<string>('SEARCH_AUTOCOMPLETE_AUTHORS');
export const [autoCompleteAuthorsSuccess, isAutoCompleteAuthorsSuccesAction] = createActionWithPayload<KeyValue[]>('SEARCH_AUTOCOMPLETE_AUTHORS_SUCCESS');
export const [autoCompleteAuthorsError, isAutoCompleteErrorAuthorsAction] = createActionWithPayload<string>('SEARCH_AUTOCOMPLETE_AUTHORS_ERROR');
